/**
 * One-time Chart.js registration for the dashboard charts (FE-3). Imported for
 * its side effect by the chart components. Only the pieces the dashboard uses
 * are registered (tree-shake-friendly).
 */
import {
  BarElement,
  CategoryScale,
  Chart,
  Filler,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from "chart.js";

Chart.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Filler,
  Tooltip,
);
